import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const SectionList = Loadable(lazy(() => import("features/section/components/List")));
const SectionPage = Loadable(lazy(() => import("features/section/components/Page")));

const routes = {
  path: "section",
  children: [
    { path: "", element: <SectionList /> },
    { path: "add", element: <SectionPage /> },
    { path: "edit/:sectionID?", element: <SectionPage /> },
  ],
};

export default routes;
